import { render, staticRenderFns } from "./adgrade.vue?vue&type=template&id=2c3c2136&scoped=true"
import script from "./adgrade.vue?vue&type=script&lang=js"
export * from "./adgrade.vue?vue&type=script&lang=js"
import style0 from "./adgrade.vue?vue&type=style&index=0&id=2c3c2136&prod&scoped=true&lang=css"
import style1 from "./adgrade.vue?vue&type=style&index=1&id=2c3c2136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c2136",
  null
  
)

export default component.exports